<template>
  <Modal title="新增/扣减费用项" v-model="visible" width="1400" class="my-modal top p-b" :mask-closable="false" :footer-hide="true">
    <Form :model="formData" ref="formValidate" class="page-form" :label-width="100">
      <p class="tips">*至少新增或扣减一种类型的费用项</p>
      <p class="tips">*如需实现新增或扣减，必须将该费用项的必填字段填写完整</p>
      <p class="tips">*同一期同一费用归属同一险种同一类型的费用只能补补结（+）或补扣款（-）一次，第二次操作为更新操作</p>
      <p class="tips">*补结的扣款费率不能超过原始费率，非补结（退保等）原因的扣款费率不能超过原始费率与历史补补结的费率之和</p>
      <br>
      <FormItem label="保单号">
        <span>{{ policyNo }}</span>
      </FormItem>

      <FormItem label="产品名称">
        <span>{{ productName }}</span>
      </FormItem>

      <FormItem label="保单年度" prop="commissionIndex" :rules="[$units.formRule.required(), $units.formRule.IntSort()]">
        <Input v-model="formData.commissionIndex" placeholder="请输入正整数" @on-blur="blurCommissionIndex" />
      </FormItem>

      <FormItem label="交费期次" prop="commissionPeriods" :rules="$units.formRule.IntSort()">
        <Input v-model="formData.commissionPeriods" placeholder="请输入正整数" />
      </FormItem>

      <FormItem label="费用归属类型" prop="commissionType" :rules="$units.formRule.required('请选择')">
        <RadioGroup v-model="formData.commissionType" @on-change="changeCommissionOwerType">
          <Radio label="1">{{ sourceType == 1 ? '下级机构' : '商户/下级机构' }}</Radio>
          <Radio label="2">业务员</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="费用归属" prop="owerId" :rules="$units.formRule.required('请选择')">
        <Select v-model="formData.owerId" placeholder="请选择" filterable clearable transfer v-if="formData.commissionType == 1" @on-change="getOrgLevelCode">
          <Option :value="item.id" v-for="(item, index) in orgList" :key="index">{{ item.name }}</Option>
        </Select>

        <Select v-model="formData.owerId" placeholder="请选择" filterable clearable transfer v-else>
          <Option :value="item.id" v-for="(item, index) in userList" :key="index">
            <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
            {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
          </Option>
        </Select>
      </FormItem>

      <FormItem label="险种名称" prop="insuranceName" :rules="$units.formRule.required('请选择')">
        <Select v-model="formData.insuranceName" placeholder="请选择" filterable clearable @on-change="changeInsuranceName">
          <Option :value="item.unique" v-for="(item, index) in insuranceList" :key="index">{{ item.insuranceName }}</Option>
        </Select>
      </FormItem>
      <!-- 基础费用 -->
      <basic
        ref="basicRef"
        :commissionIndex="formData.commissionIndex"
        :commissionType="formData.commissionType"
        :levelCode="levelCode"
        :sourceType="sourceType"
        :fee="fee"
        v-if="
          formData.commissionType == 1 ||
          (formData.commissionType == 2 && formData.owerId == salesmanId) ||
          (formData.commissionIndex > 1 && formData.owerId == this.serviceAgentId)
        "
      ></basic>

      <!-- 限时活动加费 -->
      <activity
        ref="activityRef"
        :commissionIndex="formData.commissionIndex"
        :commissionType="formData.commissionType"
        :levelCode="levelCode"
        :sourceType="sourceType"
        :fee="fee"
        v-if="
          (formData.commissionIndex == 1 && formData.commissionType == 1 && levelCode == '10001') ||
          (formData.commissionIndex == 1 && formData.commissionType == 2 && formData.owerId == salesmanId) ||
          !formData.commissionIndex
        "
      ></activity>

      <!-- 后置费用 -->
      <posterior
        ref="posteriorRef"
        :commissionIndex="formData.commissionIndex"
        :commissionType="formData.commissionType"
        :levelCode="levelCode"
        :sourceType="sourceType"
        :fee="fee"
        v-if="
          ((formData.isMain == 1 || !formData.insuranceName) && formData.commissionIndex == 1 && formData.owerId == salesmanId) ||
          (formData.commissionType == 1 && formData.commissionIndex == 1 && formData.isMain == 1)
        "
      ></posterior>

      <!-- 团队长基础费用 -->
      <groupLeaderBasic
        ref="groupLeaderBasicRef"
        :commissionIndex="formData.commissionIndex"
        :commissionType="formData.commissionType"
        :levelCode="levelCode"
        :sourceType="sourceType"
        :fee="fee"
        v-if="formData.commissionType == 2"
      ></groupLeaderBasic>

      <!-- 团队长后置费用 -->
      <groupLeaderPosterior
        ref="groupLeaderPosteriorRef"
        :commissionIndex="formData.commissionIndex"
        :commissionType="formData.commissionType"
        :levelCode="levelCode"
        :sourceType="sourceType"
        :fee="fee"
        v-if="formData.commissionType == 2 && formData.isMain == 1 && formData.commissionIndex == 1"
      ></groupLeaderPosterior>

      <!-- 续年度服务津贴 -->
      <yearServicepay
        ref="yearServicepayRef"
        :commissionIndex="formData.commissionIndex"
        :commissionType="formData.commissionType"
        :levelCode="levelCode"
        :sourceType="sourceType"
        :fee="fee"
        v-if="formData.commissionType == 1 && levelCode == '10001' && formData.commissionIndex > 1"
      ></yearServicepay>

      <div class="modal-footer">
        <Button @click="visible = false">取消</Button>
        <Button type="primary" @click="save" :loading="saveLoading">确认</Button>
      </div>
    </Form>
  </Modal>
</template>

<script>
import basic from './commissionDeductionModule/basic';
import activity from './commissionDeductionModule/activity';
import posterior from './commissionDeductionModule/posterior';
import groupLeaderBasic from './commissionDeductionModule/groupLeaderBasic';
import groupLeaderPosterior from './commissionDeductionModule/groupLeaderPosterior';
import yearServicepay from './commissionDeductionModule/yearServicepay';
import { filterTime } from '@/api/filter';

export default {
  components: {
    basic,
    activity,
    posterior,
    groupLeaderBasic,
    groupLeaderPosterior,
    yearServicepay
  },
  data() {
    return {
      visible: false,
      userList: [],
      orgList: [],
      sourceType: '',
      fee: '',
      insuranceList: [], //险种列表
      orgId: '', // 出单机构id
      salesmanId: '', // 出单业务员id
      serviceAgentId: '',
      policyNo: '',
      productName: '',
      levelCode: '10001',
      formData: {},
      saveLoading: false
    };
  },

  methods: {
    open(data) {
      this.visible = true;
      this.levelCode = '10001';
      this.sourceType = data.sourceType;
      this.$refs.formValidate.resetFields();
      this.formData = {};
      this.orgId = data.orgId;
      this.salesmanId = data.salesmanId;
      this.serviceAgentId = data.serviceAgent;
      this.getOrgList();
      this.policyNo = data.policyNo;
      this.productName = data.productName;
      this.formData.policyId = data.id;
      this.$set(this.formData, 'commissionIndex', null);
      this.$set(this.formData, 'commissionPeriods', '');
      this.$set(this.formData, 'commissionType', '1');
      this.$set(this.formData, 'owerId', '');
      this.getInsuranceType(data.policyNo);
      this.$nextTick(() => {
        this.$refs.basicRef.resetFormData();
        this.$refs.activityRef.resetFormData();
      });
    },

    // 下级机构
    getOrgList() {
      this.$http({
        url: '/buz/organizationBase/queryParentOrg',
        type: 'POST',
        data: {
          id: this.orgId
        }
      }).then(res => {
        if (this.sourceType == 1) {
          this.orgList = res.data.filter(item => item.levelCode != '10001');
        } else {
          this.orgList = res.data;
        }
      });
    },

    // 业务员
    getUserList() {
      this.$http({
        url: '/buz/userBase/getSubUser',
        type: 'GET',
        data: {}
      }).then(res => {
        this.userList = res.data;
      });
    },

    // 险种名称
    getInsuranceType(policyNo) {
      this.$http({
        url: `/buz/policy/getInsurance?policyNo=${policyNo}`,
        type: 'GET',
        data: {}
      }).then(res => {
        res.data.forEach(item => {
          item.unique = item.additionCode + item.policyNo;
          item.insuranceName = item.insuranceName + (item.isMain == '1' ? '（主险）' : '（附加险）');
        });
        this.insuranceList = res.data;
        if (res.data.length == 1) {
          this.$set(this.formData, 'insuranceName', res.data[0].unique);
          this.changeInsuranceName(res.data[0].unique);
        } else {
          this.$set(this.formData, 'insuranceName', '');
        }
      });
    },

    // 保单年度
    blurCommissionIndex(event) {
      let value = event.target._value;
      if (value == 1 && this.formData.commissionType == 2) {
        this.$set(this.formData, 'owerId', this.salesmanId);
      } else if (value > 1 && this.formData.commissionType == 2) {
        this.$set(this.formData, 'owerId', this.serviceAgentId);
      }
    },

    // 费用归属类型
    changeCommissionOwerType(value) {
      this.$set(this.formData, 'owerId', '');
      if (value == 1) {
        this.getOrgList();
      } else {
        this.getUserList();
        if (this.formData.commissionIndex == '1') {
          this.$set(this.formData, 'owerId', this.salesmanId);
        } else if (this.formData.commissionIndex) {
          this.$set(this.formData, 'owerId', this.serviceAgentId);
        }
      }
    },

    // 机构
    getOrgLevelCode(value) {
      let orgObj = this.orgList.find(item => item.id == value);
      this.levelCode = orgObj?.levelCode;
    },

    // 险种名称
    changeInsuranceName(value) {
      let insuranceObj = this.insuranceList.find(item => item.unique == value);
      this.fee = insuranceObj?.fee || 0;
      this.formData.isMain = insuranceObj?.isMain;
      this.formData.isMainAddition = insuranceObj?.isMainAddition;
      this.formData.additionCode = insuranceObj?.additionCode;
    },

    // 基础费用-扣款原因切换
    changeDeductType(value) {
      if (value != 5) {
        this.$set(this.formData, 'commission', '');
        this.$set(this.formData, 'commissionPrice', '');
      } else {
        this.$set(this.formData, 'commissionPrice', Number(this.formData.commission).div(100).mul(this.formData.fee));
      }
    },

    // 基础费用-费用
    calculateCommission($event) {
      if (!$event.target._value || (this.formData.isDeduct == 1 && this.formData.deductType != 5)) return;
      this.$set(this.formData, 'commissionPrice', Number($event.target._value).div(100).mul(this.formData.fee));
    },

    async save() {
      this.$refs.formValidate.validate(async valid => {
        if (valid) {
          var formData = JSON.parse(JSON.stringify(this.formData));
          let data = {
            policyNo: this.policyNo,
            policyId: formData.policyId,
            isMain: formData.isMain,
            isMainAddition: formData.isMainAddition,
            additionCode: formData.additionCode,
            owerId: formData.owerId,
            commissionIndex: formData.commissionIndex,
            commissionPeriods: formData.commissionPeriods ? formData.commissionPeriods : formData.commissionIndex,
            CommissionLogInfoList: []
          };
          // 基础费用
          if (
            formData.commissionType == 1 ||
            (formData.commissionType == 2 && formData.owerId == this.salesmanId) ||
            (formData.commissionIndex > 1 && formData.owerId == this.serviceAgentId)
          ) {
            var basicFormData = await this.$refs.basicRef.validate().then(res => res);
            if(!basicFormData.isError) {
              data.CommissionLogInfoList.push({
                owerType: formData.commissionType == 1 ? '1' : '3', //归属人类型 1、机构 2、团队长 3、业务员
                type: '1', //1、基础  2、活动  3、后置
                fee: basicFormData.isDeduct == 1 && basicFormData.deductType != 5 ? basicFormData.fee * -1 : basicFormData.fee, //保费
                commission: basicFormData.isDeduct == 1 ? Number(basicFormData.commission).div(100) * -1 : Number(basicFormData.commission).div(100),
                commissionBak: basicFormData.commission, //原始费用
                commissionPrice: basicFormData.isDeduct == 1 ? basicFormData.commissionPrice * -1 : basicFormData.commissionPrice, //费用
                settlementCommissionPrice: basicFormData.isDeduct == 1 ? basicFormData.settlementCommissionPrice * -1 : basicFormData.settlementCommissionPrice, //结算费用
                settlementStatus: basicFormData.settlementStatus, //结算状态
                settlementCommission:
                  basicFormData.isDeduct == 1 ? Number(basicFormData.settlementCommission).div(100) * -1 : Number(basicFormData.settlementCommission).div(100), //结算费率
                paymentDate: basicFormData.paymentDate ? filterTime(basicFormData.paymentDate, 'YYYY-MM-DD') : '', //打款日期
                isDeduct: basicFormData.deductType == 5 ? '0' : basicFormData.isDeduct,
                deductType: basicFormData.deductType == 5 ? '' : basicFormData.deductType,
                deductMsg: basicFormData.deductMsg
              });
            }
          }
          // 后置费用
          if (
            (formData.isMain == 1 && formData.commissionIndex == 1 && formData.owerId == this.salesmanId) ||
            (formData.commissionType == 1 && formData.commissionIndex == 1 && formData.isMain == 1)
          ) {
            var posteriorFormData = await this.$refs.posteriorRef.validate().then(res => res);
            if(!posteriorFormData.isError) {
              data.CommissionLogInfoList.push({
                owerType: formData.commissionType == 1 ? '1' : '3', //归属人类型 1、机构 2、团队长 3、业务员
                type: '3', //1、基础  2、活动  3、后置
                fee: posteriorFormData.fee, //保费
                commissionBak: posteriorFormData.commission, //原始费用
                commission: posteriorFormData.isDeduct == 1 ? Number(posteriorFormData.commission).div(100) * -1 : Number(posteriorFormData.commission).div(100),
                commissionPrice: posteriorFormData.isDeduct == 1 ? posteriorFormData.commissionPrice * -1 : posteriorFormData.commissionPrice, //费用
                settlementStatus: posteriorFormData.settlementStatus, //结算状态
                settlementCommission:
                  posteriorFormData.isDeduct == 1
                    ? Number(posteriorFormData.settlementCommission).div(100) * -1
                    : Number(posteriorFormData.settlementCommission).div(100), //结算费率
                settlementCommissionPrice:
                  posteriorFormData.isDeduct == 1 ? posteriorFormData.settlementCommissionPrice * -1 : posteriorFormData.settlementCommissionPrice, //结算费用
                paymentDate: posteriorFormData.paymentDate ? filterTime(posteriorFormData.paymentDate, 'YYYY-MM-DD') : '', //打款日期
                isDeduct: posteriorFormData.deductType == 5 ? '0' : posteriorFormData.isDeduct
              });
            }
          }
          // 团队长基础管理费
          if (formData.commissionType == 2) {
            var groupBasicFormData = await this.$refs.groupLeaderBasicRef.validate().then(res => res);
            if(!groupBasicFormData.isError) {
              data.CommissionLogInfoList.push({
                owerType: '2', // 2、团队长
                type: '1', // 1、基础  3、后置
                fee: groupBasicFormData.isDeduct == 1 && groupBasicFormData.deductType != 5 ? groupBasicFormData.fee * -1 : groupBasicFormData.fee, //保费
                commissionBak: groupBasicFormData.commission, //原始费用
                commission:
                  groupBasicFormData.isDeduct == 1 ? Number(groupBasicFormData.commission).div(100) * -1 : Number(groupBasicFormData.commission).div(100),
                commissionPrice: groupBasicFormData.isDeduct == 1 ? groupBasicFormData.commissionPrice * -1 : groupBasicFormData.commissionPrice, //费用
                settlementStatus: groupBasicFormData.settlementStatus, //结算状态
                settlementCommission:
                  groupBasicFormData.isDeduct == 1
                    ? Number(groupBasicFormData.settlementCommission).div(100) * -1
                    : Number(groupBasicFormData.settlementCommission).div(100), //结算费率
                settlementCommissionPrice:
                  groupBasicFormData.isDeduct == 1 ? groupBasicFormData.settlementCommissionPrice * -1 : groupBasicFormData.settlementCommissionPrice, //结算费用
                paymentDate: groupBasicFormData.paymentDate ? filterTime(groupBasicFormData.paymentDate, 'YYYY-MM-DD') : '', //打款日期
                isDeduct: groupBasicFormData.deductType == 5 ? '0' : groupBasicFormData.isDeduct,
                deductType: groupBasicFormData.deductType == 5 ? '' : groupBasicFormData.deductType,
                deductMsg: groupBasicFormData.deductMsg
              });
            }
          }
          // 团队长后置费用
          if (formData.commissionType == 2 && formData.isMain == 1 && formData.commissionIndex == 1) {
            var groupPosteriorFormData = await this.$refs.groupLeaderPosteriorRef.validate().then(res => res);
            if(!groupPosteriorFormData.isError) {
              data.CommissionLogInfoList.push({
                owerType: '2', // 2、团队长
                type: '3', //1、基础  3、后置
                fee: groupPosteriorFormData.fee, //保费
                commissionBak: groupPosteriorFormData.commission, //原始费用
                commission:
                  groupPosteriorFormData.isDeduct == 1
                    ? Number(groupPosteriorFormData.commission).div(100) * -1
                    : Number(groupPosteriorFormData.commission).div(100),
                commissionPrice: groupPosteriorFormData.isDeduct == 1 ? groupPosteriorFormData.commissionPrice * -1 : groupPosteriorFormData.commissionPrice, //费用
                settlementStatus: groupPosteriorFormData.settlementStatus, //结算状态
                settlementCommission:
                  groupPosteriorFormData.isDeduct == 1
                    ? Number(groupPosteriorFormData.settlementCommission).div(100) * -1
                    : Number(groupPosteriorFormData.settlementCommission).div(100), //结算费率
                settlementCommissionPrice:
                  groupPosteriorFormData.isDeduct == 1 ? groupPosteriorFormData.settlementCommissionPrice * -1 : groupPosteriorFormData.settlementCommissionPrice, //结算费用
                paymentDate: groupPosteriorFormData.paymentDate ? filterTime(groupPosteriorFormData.paymentDate, 'YYYY-MM-DD') : '', //打款日期
                isDeduct: groupPosteriorFormData.deductType == 5 ? '0' : groupPosteriorFormData.isDeduct
              });
            }
          }
          // 限时活动加费
          if (
            (formData.commissionIndex == 1 && formData.commissionType == 1 && this.levelCode == '10001') ||
            (formData.commissionIndex == 1 && formData.commissionType == 2 && formData.owerId == this.salesmanId)
          ) {
            var activityFormData = await this.$refs.activityRef.validate().then(res => res);
            if(!activityFormData.isError) {
              data.CommissionLogInfoList.push({
                owerType: formData.commissionType == 1 ? '1' : '3', //归属人类型 1、机构 2、团队长 3、业务员
                type: '2', //1、基础  2、活动  3、后置
                fee: activityFormData.isDeduct == 1 && activityFormData.deductType != 5 ? activityFormData.fee * -1 : activityFormData.fee, //保费
                commission: activityFormData.isDeduct == 1 ? Number(activityFormData.commission).div(100) * -1 : Number(activityFormData.commission).div(100),
                commissionBak: activityFormData.commission, //原始费用
                commissionPrice: activityFormData.isDeduct == 1 ? activityFormData.commissionPrice * -1 : activityFormData.commissionPrice, //费用
                settlementCommissionPrice:
                  activityFormData.isDeduct == 1 ? activityFormData.settlementCommissionPrice * -1 : activityFormData.settlementCommissionPrice, //结算费用
                settlementStatus: activityFormData.settlementStatus, //结算状态
                settlementCommission:
                  activityFormData.isDeduct == 1
                    ? Number(activityFormData.settlementCommission).div(100) * -1
                    : Number(activityFormData.settlementCommission).div(100), //结算费率
                paymentDate: activityFormData.paymentDate ? filterTime(activityFormData.paymentDate, 'YYYY-MM-DD') : '', //打款日期
                isDeduct: activityFormData.deductType == 5 ? '0' : activityFormData.isDeduct,
                deductType: activityFormData.deductType == 5 ? '' : activityFormData.deductType,
                deductMsg: activityFormData.deductMsg
              });
            }
          }
          // 续年度服务津贴
          if (formData.commissionType == 1 && this.levelCode == '10001' && formData.commissionIndex > 1) {
            var yearServiceFormData = await this.$refs.yearServicepayRef.validate().then(res => res);
            if(!yearServiceFormData.isError) {
              data.CommissionLogInfoList.push({
                owerType: '1',
                type: '4',
                fee: yearServiceFormData.isDeduct == 1 && yearServiceFormData.deductType != 5 ? yearServiceFormData.fee * -1 : yearServiceFormData.fee, //保费
                commission:
                  yearServiceFormData.isDeduct == 1 ? Number(yearServiceFormData.commission).div(100) * -1 : Number(yearServiceFormData.commission).div(100),
                commissionBak: yearServiceFormData.commission, //原始费用
                commissionPrice: yearServiceFormData.isDeduct == 1 ? yearServiceFormData.commissionPrice * -1 : yearServiceFormData.commissionPrice, //费用
                settlementCommissionPrice:
                  yearServiceFormData.isDeduct == 1 ? yearServiceFormData.settlementCommissionPrice * -1 : yearServiceFormData.settlementCommissionPrice, //结算费用
                settlementStatus: yearServiceFormData.settlementStatus, //结算状态
                settlementCommission:
                  yearServiceFormData.isDeduct == 1
                    ? Number(yearServiceFormData.settlementCommission).div(100) * -1
                    : Number(yearServiceFormData.settlementCommission).div(100), //结算费率
                paymentDate: yearServiceFormData.paymentDate ? filterTime(yearServiceFormData.paymentDate, 'YYYY-MM-DD') : '', //打款日期
                isDeduct: yearServiceFormData.deductType == 5 ? '0' : yearServiceFormData.isDeduct,
                deductType: yearServiceFormData.deductType == 5 ? '' : yearServiceFormData.deductType,
                deductMsg: yearServiceFormData.deductMsg
              });
            }
          }
          data.CommissionLogInfoList = data.CommissionLogInfoList.filter(item => item.commissionBak || ([1,2,3,4].includes(item.deductType*1)));
          // 效验必填一个费用
          if (data.CommissionLogInfoList.length == 0) {
            this.$notice.error('至少需要将一种费用类型下的必填字段填写完整');
            return;
          }
          data.CommissionLogInfoList.forEach(item => {
            delete item.commissionBak
            if (item.settlementStatus == '0') {
              delete item.settlementCommission;
              delete item.settlementCommissionPrice;
            }
            if (item.isDeduct == 1 && item.settlementStatus == '1' && item.deductType != '5') {
              delete item.settlementCommission;
            }
          });
          this.saveLoading = true;
          this.$http({
            url: '/buz/commissionLog/addRepairLogs',
            type: 'POST',
            data
          })
            .then(res => {
              this.$emit('success');
              this.visible = false;
              this.$notice.success('操作成功');
            })
            .finally(() => {
              this.saveLoading = false;
            });
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.tips {
  color: #ed4014;
  font-size: 14px;
  margin-bottom: 6px;
  margin-left: 30px;
}
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  &.red {
    background: #e3461f;
  }
}

.type-container {
  margin: 20px 0;
  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .item {
    width: 25%;
    .input {
      width: 92%;
    }
    .unit {
      float: right;
    }
  }
}
.modal-footer {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  .ivu-btn {
    min-width: 80px;
    width: auto;
  }
}
</style>
